/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tools_Gmail_Ingest_Attachments_ErrorInputs */

const es_tools_gmail_ingest_attachments_error = /** @type {(inputs: Tools_Gmail_Ingest_Attachments_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error al ingestar adjuntos de Gmail`)
};

const en_tools_gmail_ingest_attachments_error = /** @type {(inputs: Tools_Gmail_Ingest_Attachments_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error ingesting Gmail attachments`)
};

/**
* | output |
* | --- |
* | "Error ingesting Gmail attachments" |
*
* @param {Tools_Gmail_Ingest_Attachments_ErrorInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const tools_gmail_ingest_attachments_error = /** @type {((inputs?: Tools_Gmail_Ingest_Attachments_ErrorInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tools_Gmail_Ingest_Attachments_ErrorInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tools_gmail_ingest_attachments_error(inputs)
	return en_tools_gmail_ingest_attachments_error(inputs)
});
export { tools_gmail_ingest_attachments_error as "tools.gmail.ingest_attachments_error" }